import { ArrowForwardRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { getContractToSign } from '@webapps/business';
import { useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import { CircularProgress } from '@material-ui/core';

const InformationSign = ({ opcoRecord, refetch }) => {
  const { classes, css, cx, global } = useStyles(styles);
  const { addToast } = useToast();

  const [open, setOpen] = useState(false);

  const {
    error,
    isLoading: isLoadingContract,
    isSuccess: isSuccessContract,
    mutateAsync: mutateGetContractToSign,
    data: contract = {},
  } = useMutation(getContractToSign);

  useEffect(() => {
    if (isSuccessContract) {
      setOpen(true);
    } else if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccessContract, error, addToast]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'closeModal') {
        setOpen(false);
        refetch();
        addToast({ status: 'success', message: 'Contrat signé avec succès !' });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [refetch, addToast]);

  return (
    <>
      <div
        className={cx(global.fcjc, classes.information, { [classes.disabled]: isLoadingContract })}
        onClick={() => !isLoadingContract && mutateGetContractToSign({ id: opcoRecord.id, from: 'cfa' })}
      >
        <div className={global.frac} style={{ gap: 8 }}>
          <div className={classes.contractSpan}>CONTRAT ET CONVENTION À SIGNER</div>
          <h1 className={global.title} style={{ margin: 0 }}>
            Signer le contrat et la convention de formation
          </h1>
          {isLoadingContract ? (
            <CircularProgress size={12} style={{ color: '#0060F9' }} />
          ) : (
            <ArrowForwardRounded style={{ color: '#0060F9', fontSize: 12 }} />
          )}
        </div>
        <div className={classes.kawaiiText}>En signant ces documents, vous les signerez.</div>
      </div>
      <Modal
        withStep={false}
        onCancel={() => setOpen(false)}
        open={open}
        height="90%"
        width={1000}
        title="Signer votre contrat"
      >
        <iframe src={contract.signature_link} width="100%" height="600px" />
      </Modal>
    </>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  information: {
    backgroundColor: '#C0D9FF',
    cursor: 'pointer',
    gap: 8,
    padding: 20,
    borderRadius: 10,
    '&:hover h1': {
      color: '#0060F9',
    },
  },
  disabled: {
    transition: 'all 0.3s ease',
    filter: 'grayscale(100%)',
    cursor: 'not-allowed',
    '&:hover h1': {
      color: '#152652',
    },
  },
  contractSpan: {
    backgroundColor: '#0060F9',
    borderRadius: '5px',
    padding: '0px 5px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    color: 'white',
  },
  kawaiiText: {
    fontSize: 12,
  },
});

export default InformationSign;